import { FETCHING_ACTIVE_OR_COMING_SOON, FETCHED_ACTIVE_OR_COMING_SOON, FETCHING_CLOSED, FETCHED_CLOSED } from '../../actions/HomepageActions';
import Raffle from '../../models/Raffle';

export default class FetchReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = {}, action) {
		let items;
		switch (action.type) {
			case FETCHING_ACTIVE_OR_COMING_SOON:
				return {
					...state,
					activeOrComingSoonRaffles: {
						...state.activeOrComingSoonRaffles,
						fetching: true
					}
				};
			case FETCHED_ACTIVE_OR_COMING_SOON:
				items = [...state.activeOrComingSoonRaffles.items, ...action.raffles.map((raffle) => Raffle.normalize(raffle))];
				return {
					...state,
					activeOrComingSoonRaffles: {
						items,
						fetching: false,
						moreAvailable: items.length < action.total,
						page: action.page
					}
				};
			case FETCHING_CLOSED:
				return {
					...state,
					closedRaffles: {
						...state.closedRaffles,
						fetching: true
					}
				};
			case FETCHED_CLOSED:
				items = [...state.closedRaffles.items, ...action.raffles.map((raffle) => Raffle.normalize(raffle))];
				return {
					...state,
					closedRaffles: {
						items,
						fetching: false,
						moreAvailable: items.length < action.total,
						page: action.page
					}
				};
			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./reducers/homepage/FetchReducer.js